import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { NewbuildingActions } from 'shared/components/NewbuildingActions';
import { canMakeFlatViewOrder, getIsCallbackAvailable } from 'shared/selectors';

import { CallBackButtonContainer } from '../CallBackButton';
import { FlatViewButtonContainer } from '../FlatViewButtonContainer';

export const NewbuildingActionsContainer = () => {
  const isCallbackAvailable = useSelector(getIsCallbackAvailable);
  const isFlatViewButtonAvailable = useSelector(canMakeFlatViewOrder);

  if (!isCallbackAvailable && !isFlatViewButtonAvailable) {
    return null;
  }

  return (
    <CardSectionNew hideForPrint>
      <NewbuildingActions
        callbackButton={
          <CallBackButtonContainer
            placeType="floating_block"
            theme="fill_primary"
            fullWidth={false}
            beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
            callbackButtonText="Заказать звонок"
          />
        }
        flatViewButton={<FlatViewButtonContainer />}
      />
    </CardSectionNew>
  );
};
